import { Modal, ModalProps, Row } from 'antd';
import outsourcingLogo from '../../assets/images/outsourcing.png';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../enums';

export const OutsourcingModal: React.FC<ModalProps> = ({ open, onCancel }) => {
	const navigate = useNavigate();
	return (
		<Modal
			open={open}
			onCancel={onCancel}
			okText="Get started"
			onOk={e => {
				navigate(AppRoutes.OUTSOURCING);
				onCancel && onCancel(e);
			}}
		>
			<Row className="d-flex justify-content-center mb-4">
				<img
					src={outsourcingLogo}
					alt="outsourcing logo"
					style={{ boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)', padding: '15px' }}
				/>
			</Row>
			<Row className="d-flex justify-content-center">
				<h5>New feature available!</h5>
			</Row>

			<Row className="d-flex justify-content-center">
				<p className="text-muted">
					Exciting News! We've new outsourcing feature, empowering you to take control of your workforce like
					never before. Elevate your team and future-proof your business. Explore opportunities now!
				</p>
			</Row>
		</Modal>
	);
};
